import "~/misc/common";
import { p } from "~/misc/common";
import { Controller } from "@hotwired/stimulus";

import { ActiveElement, Chart, ChartDataset, ChartEvent, ScatterDataPoint } from "chart.js";
import { lineChartOptions } from "~/misc/charts";
import moment from "moment";

interface DateScatterPoint {
  x: string;
  y: number;
}

export default class extends Controller {

  connect() {
    p('initAccountsShow');
    const balances = $('#toJs').data('balances');
    const account_id = $('#toJs').data('accountid');

    const ctx = $('#lastBalances')[0] as HTMLCanvasElement;
    var options = Object.assign({}, lineChartOptions) as any;
    options.scales.x = {
      type: 'time',
      time: {
        unit: 'day',
        tooltipFormat: 'YYYY.MM.DD',
        displayFormats: {
          minute: 'HH:mm',
          hour: 'MM.DD HH:mm',
          day: 'MM.DD'
        }
      }
    };
    //options.scales.y = { min: 0 };
    //options.scales.x.title.text = 'Normálerő, N [kN]';
    //options.scales.x.title.display = true;
    //options.scales.y.title.text = 'Maximális nyomaték, M [kNm]';
    options.showLine = true;
    options.plugins.tooltip = {
      callbacks: {
        label: function (d: any) {
          //p(d);
          //return `${d.label}: ${d.formattedValue} HUF`;
          return `${d.label} | ${d.formattedValue}`;
        }
      }
    };
    options.plugins.zoom = {
      pan: {
        enabled: true,
        mode: 'x'
        //modifierKey: 'ctrl'
      },
      zoom: {
        wheel: { enabled: true },
        pinch: { enabled: true },
        mode: 'x'
        // drag: true // uncomment if you want drag zoom
      },
      limits: {
        x: {
          minRange: 30 * 60 * 1000
        }
      }
    };
    options.onClick = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
      if (elements.length === 0) return;

      const { index, datasetIndex } = elements[0];
      //p(chart.data.datasets[datasetIndex].data[index]);
      const point = chart.data.datasets[datasetIndex].data[index]! as unknown as DateScatterPoint;;
      const date = moment(point.x);
      const gteq = date.format('YYYY-MM-DD');
      const lt = date.add(1, 'day').format('YYYY-MM-DD');
      const url = `/transactions?q[account_id_eq]=${account_id}&q[date_gteq]=${gteq}&q[date_lt]=${lt}`;
      window.open(url, '_blank');
    };
    new Chart(ctx, {
      type: 'scatter',
      data: {
        datasets: balances,
      },
      options: options
    });
  }
}